import { Link } from 'react-router-dom';

const services = [
  {
    id: 'dtf',
    icon: 'ri-t-shirt-line',
    title: 'Impresión DTF',
    subtitle: 'Tecnología Avanzada de Transferencia Directa',
    description: 'La impresión DTF (Direct to Film) es la tecnología más avanzada para personalizar prendas textiles. Permite imprimir diseños con colores vibrantes, detalles precisos y una durabilidad excepcional en cualquier tipo de tela.',
    benefits: ['Colores vibrantes y duraderos', 'Aplicable a cualquier tipo de tela', 'Resistente a múltiples lavados', 'Detalles de alta precisión', 'Sin mínimo de piezas', 'Entrega rápida'],
    image: 'https://public.readdy.ai/ai/img_res/0ce6f97c1b6f8ad453dddd696f3cf175.jpg',
  },
  {
    id: 'sublimacion',
    icon: 'ri-cup-line',
    title: 'Sublimación',
    subtitle: 'Personalización Permanente en Todo Tipo de Productos',
    description: 'La sublimación es el proceso ideal para personalizar tazas, botellas, artículos rígidos y prendas de poliéster. Los colores se integran al material de forma permanente, garantizando que nunca se desvanezcan ni descascarillen.',
    benefits: ['Colores permanentes que no se desvanecen', 'Ideal para tazas y botellas', 'Perfecto para prendas de poliéster', 'Acabado profesional sin relieve', 'Resistente al calor y lavado', 'Amplia variedad de productos'],
    image: 'https://readdy.ai/api/search-image?query=sublimation%20printing%20process%20colorful%20mugs%20cups%20bottles%20with%20custom%20designs%2C%20professional%20sublimation%20equipment%2C%20vibrant%20product%20photography%2C%20clean%20studio%20background&width=800&height=600&seq=svc002&orientation=landscape',
  },
  {
    id: 'comercial',
    icon: 'ri-printer-line',
    title: 'Impresión Comercial',
    subtitle: 'Material Profesional para tu Negocio',
    description: 'Ofrecemos soluciones completas de impresión comercial para empresas y emprendedores. Desde flyers y tarjetas de presentación hasta banners y material publicitario de gran formato, todo con acabados profesionales.',
    benefits: ['Flyers de alto impacto visual', 'Tarjetas de presentación premium', 'Banners y material de gran formato', 'Brochures y catálogos', 'Material para eventos', 'Acabados mate y brillante'],
    image: 'https://readdy.ai/api/search-image?query=professional%20commercial%20printing%20business%20cards%20flyers%20brochures%20banners%20spread%20on%20clean%20surface%2C%20high%20quality%20print%20materials%2C%20marketing%20materials%2C%20vibrant%20colors&width=800&height=600&seq=svc003&orientation=landscape',
  },
  {
    id: 'microperforados',
    icon: 'ri-car-line',
    title: 'Microperforados',
    subtitle: 'Publicidad Exterior de Alto Impacto',
    description: 'Los viniles microperforados son la solución perfecta para publicidad en vehículos, vitrinas y espacios comerciales. Permiten visibilidad desde el exterior mientras mantienen la visión desde el interior.',
    benefits: ['Visibilidad exterior total', 'Visión interior preservada', 'Ideal para vehículos y vitrinas', 'Resistente a la intemperie', 'Fácil instalación y remoción', 'Impresión de alta resolución'],
    image: 'https://readdy.ai/api/search-image?query=vehicle%20wrap%20microperforated%20vinyl%20advertising%20on%20car%20window%2C%20professional%20vehicle%20branding%2C%20colorful%20commercial%20graphics%2C%20business%20advertising%20on%20automobile&width=800&height=600&seq=svc004&orientation=landscape',
  },
];

const ServicesPage = () => {
  return (
    <div className="pt-20">
      {/* Hero */}
      <section className="bg-[#0A1628] py-20 text-center">
        <div className="max-w-4xl mx-auto px-4 md:px-8">
          <span className="text-[#FF6B35] text-sm font-semibold uppercase tracking-widest">Lo que ofrecemos</span>
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mt-4 mb-6">
            Servicios Profesionales de Impresión
          </h1>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            Más de 30 años de experiencia respaldan cada servicio que ofrecemos. Calidad, precisión y cumplimiento en cada proyecto.
          </p>
        </div>
      </section>

      {/* Services Detail */}
      <section className="py-8 bg-white">
        {services.map((service, index) => (
          <div key={service.id} className={`py-20 ${index % 2 === 1 ? 'bg-[#F8F9FA]' : 'bg-white'}`}>
            <div className="max-w-7xl mx-auto px-4 md:px-8">
              <div className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${index % 2 === 1 ? 'lg:flex-row-reverse' : ''}`}>
                {/* Image */}
                <div className={`relative rounded-3xl overflow-hidden h-[400px] ${index % 2 === 1 ? 'lg:order-2' : ''}`}>
                  <img src={service.image} alt={service.title} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A1628]/30 to-transparent"></div>
                </div>

                {/* Content */}
                <div className={index % 2 === 1 ? 'lg:order-1' : ''}>
                  <div className="inline-flex items-center gap-2 bg-[#FF6B35]/10 text-[#FF6B35] text-xs font-semibold px-3 py-1.5 rounded-full mb-4">
                    <i className={`${service.icon}`}></i>
                    {service.subtitle}
                  </div>
                  <h2 className="text-3xl md:text-4xl font-extrabold text-[#0A1628] mb-5">{service.title}</h2>
                  <p className="text-[#6C757D] text-base leading-relaxed mb-8">{service.description}</p>

                  <ul className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-10">
                    {service.benefits.map((b) => (
                      <li key={b} className="flex items-center gap-3">
                        <div className="w-5 h-5 flex items-center justify-center bg-[#FF6B35] rounded-full flex-shrink-0">
                          <i className="ri-check-line text-white text-xs"></i>
                        </div>
                        <span className="text-[#0A1628] text-sm font-medium">{b}</span>
                      </li>
                    ))}
                  </ul>

                  <div className="flex flex-col sm:flex-row gap-4">
                    <a
                      href="https://wa.me/17542034748"
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="inline-flex items-center justify-center gap-2 bg-[#FF6B35] text-white font-bold px-7 py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#e85a24] transition-colors"
                    >
                      Solicitar Cotización
                      <i className="ri-arrow-right-line"></i>
                    </a>
                    <a
                      href="https://wa.me/17542034748"
                      target="_blank"
                      rel="nofollow noreferrer"
                      className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold px-7 py-4 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#1ebe5a] transition-colors"
                    >
                      <i className="ri-whatsapp-line"></i>
                      WhatsApp
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#0A1628] text-center">
        <div className="max-w-3xl mx-auto px-4 md:px-8">
          <h2 className="text-3xl md:text-5xl font-extrabold text-white mb-6">¿Tienes un proyecto en mente?</h2>
          <p className="text-white/60 text-lg mb-10">Contáctanos hoy y recibe una cotización personalizada sin compromiso.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <a
              href="https://wa.me/17542034748"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#FF6B35] text-white font-bold px-10 py-5 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#e85a24] transition-colors text-lg"
            >
              Solicitar Cotización
              <i className="ri-arrow-right-line text-xl"></i>
            </a>
            <a
              href="https://wa.me/17542034748"
              target="_blank"
              rel="nofollow noreferrer"
              className="inline-flex items-center justify-center gap-2 bg-[#25D366] text-white font-bold px-10 py-5 rounded-full whitespace-nowrap cursor-pointer hover:bg-[#1ebe5a] transition-colors text-lg"
            >
              <i className="ri-whatsapp-line text-xl"></i>
              Hablar por WhatsApp
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ServicesPage;
